"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function sequenceFocus(ctx, node) {
  ctx.beginPath();
  ctx.rect(node.rect.x, node.rect.y, node.rect.width, node.rect.height);

  if (this.fillStyle) {
    ctx.fillStyle = this.fillStyle;
  } else {
    ctx.fillStyle = '#fff';
  }

  ctx.fill();
  ctx.stroke();
}

exports.sequenceFocus = sequenceFocus;